import vert from '../glsl/scenes.vert'
import frag from '../glsl/scenes.frag'
import vidFrag from '../glsl/alphaVid.frag'
import normalFrag from '../glsl/scenesNormal.frag'
import rayFrag from '../glsl/scenesWithRay.frag'
import godrayFrag from '../glsl/scenesWithGodray.frag'
import dephyRayFrag from '../glsl/scenesWithDephyRay.frag'


//import RenderLayers from '../../config/RenderLayers'
let cache = {}
const textureLoader = new THREE.TextureLoader()



AFRAME.registerComponent('scenes', {
  dependencies: ['geometry'],
  schema: {
    fxOn: {
      type: 'boolean',
    },
    bg: {
      type: 'asset',
    },
    char1: {
      type: 'asset',
    },
    char2: {
      type: 'asset',
    },
    depthMap: {
      type: 'asset',
    },
    scene5: {
      type: 'asset',
    },
    progress: {
      type: 'number'
    },
    mode: {
      type: 'number'
    },
    rayDecay: {
      type: 'number'
    },
    rayDensity: {
      type: 'number'
    },
    rayWeight: {
      type: 'number'
    },
    play: {
      default: false
    },

    sceneEntered: {
      default: false
    },
    shaderFx:{
      default: 'ray'
    },

    rrs: {
      type: 'number'
    },
    rgs: {
      type: 'number'
    },
    rbs: {
      type: 'number'
    },
    r1x: {
      type: 'number'
    },
    r1y: {
      type: 'number'
    },
    r1dx: {
      type: 'number'
    },
    r1dy: {
      type: 'number'
    },
    r2x: {
      type: 'number'
    },
    r2y: {
      type: 'number'
    },
    r2dx: {
      type: 'number'
    },
    r2dy: {
      type: 'number'
    },
    ds: {
      type: 'number'
    },
    de: {
      type: 'number'
    },

  },
  init: function() {


    this.textureCache = this.el.sceneEl.systems['texture-cache']

    const mesh = this.el.getObject3D('mesh')
    this.mesh = mesh
    const textureWidth = this.el.components.geometry.data.width
    const textureHeight = this.el.components.geometry.data.height
    const textureRatio = textureWidth / textureHeight
    //console.log(999, textureHeight, textureWidth)

    const viewportCanvas = document.querySelector('.a-canvas')



    console.log(10101010, this.el.sceneEl.renderer.getPixelRatio(), this.el.sceneEl.renderer.capabilities.getMaxAnisotropy())

    let viewWidth, viewHeight

    viewWidth = viewportCanvas.attributes.width.value
    viewHeight = viewportCanvas.attributes.height.value
    console.log(999000, viewWidth, viewHeight)

    this.lastFrameTime = 0
    this.LOADED = false

    this.shaderInit()
    this.mesh.material = this.material
    //console.log('FXXXX!!!!!!!', this.data.fxOn)

    if (this.data.fxOn)
      this.mesh.material.fragmentShader = rayFrag
    else
      this.mesh.material.fragmentShader = normalFrag


  },
  adultMode: function() {
    if (!this.data.fxOn) return
    //let depthMap = this.data.depthMap.getAttribute('src')

    //let depthMap = this.textureCache.getTexture(this.data.depthMap)

    //let scene5 = this.data.scene5.getAttribute('src')
    this.mesh.material.uniforms.texture4.value = this.textureCache.getTexture(this.data.depthMap)
    //this.dephyRayMat.uniforms.texture5.value = textureLoader.load(scene5)
    //this.material.uniforms.tVideo.needsUpdate = true
    this.mesh.material.fragmentShader = dephyRayFrag
    this.mesh.material.needsUpdate = true
  },
  kidMode: function() {
    if (!this.data.fxOn) return
    //this.mesh.material = this.normalMat
    this.mesh.material.fragmentShader = normalFrag
    this.mesh.material.needsUpdate = true
  },
  update: function(oldData) {

    if (!this.data.fxOn) return




    if (this.data.sceneEntered) {
      if (this.data.mode === 1)
        this.kidMode()
      else{
        this.adultMode()
      }
    } else {
      this.mesh.material.fragmentShader = rayFrag
      this.mesh.material.needsUpdate = true
    }


  },
  viewportResize: function() {
    const viewportCanvas = document.querySelector('.a-canvas')

    let viewWidth, viewHeight

    viewWidth = viewportCanvas.attributes.width.value
    viewHeight = viewportCanvas.attributes.height.value


    this.mesh.material.uniforms.viewResolution.value = [viewWidth, viewHeight]
    //this.dephyRayMat.uniforms.viewResolution.value = [viewWidth, viewHeight]
    //console.log('resize', viewWidth, viewHeight)
  },

  remove: function() {
    window.removeEventListener('resize', this.viewportResize)
  },
  tick: function(time, timeDelta) {
    if (!this.data.fxOn) return

    if (this.data.shaderFx === 'dephyRay') {
      let offsetX = this.el.sceneEl.camera.el.components['gyro-position'].offset.x/496.0
      let offsetY = this.el.sceneEl.camera.el.components['gyro-position'].offset.y/50.0
      this.mesh.material.uniforms.offsetX.value = offsetX
      this.mesh.material.uniforms.offsetY.value = offsetY
    }
    //this.material.uniforms.time.value = time
    this.mesh.material.uniforms.time.value = time
    //console.log(offsetX, offsetY, time)


  },

  tock: function(time, timeDelta) {},
  play: function() {},
  pause: function() {},
  updateSchema: function(data) {},

  shaderInit: function () {
    const textureWidth = this.el.components.geometry.data.width
    const textureHeight = this.el.components.geometry.data.height
    const textureRatio = textureWidth / textureHeight

    //const maxAnisotropy = this.el.sceneEl.renderer.capabilities.getMaxAnisotropy()


    let bg = this.textureCache.getTexture(this.data.bg)
    //let bgSrc = this.data.bg.getAttribute('src')
    //let bg = textureLoader.load(bgSrc)
    bg.minFilter = THREE.LinearFilter
    //bg.anisotropy = 1
    //bg.minFilter = THREE.NearestFilter
    //let depthMapSrc = this.data.depthMap.getAttribute('src')
    //let depthMap = textureLoader.load(depthMapSrc)

    this.material = new THREE.ShaderMaterial({
      //transparent: true,

      uniforms: {
        rrs: {
          type: 'f',
          value: this.data.rrs,
        },
        rgs: {
          type: 'f',
          value: this.data.rgs,
        },
        rbs: {
          type: 'f',
          value: this.data.rbs,
        },
        r1x: {
          type: 'f',
          value: this.data.r1x,
        },
        r1y: {
          type: 'f',
          value: this.data.r1y,
        },
        r1dx: {
          type: 'f',
          value: this.data.r1dx,
        },
        r1dy: {
          type: 'f',
          value: this.data.r1dy,
        },
        r2x: {
          type: 'f',
          value: this.data.r2x,
        },
        r2y: {
          type: 'f',
          value: this.data.r2y,
        },
        r2dx: {
          type: 'f',
          value: this.data.r2dx,
        },
        r2dy: {
          type: 'f',
          value: this.data.r2dy,
        },

        texture1: {
          type: 't',
          value: bg
        },
        texture4: {
          type: 't',


        },
        viewResolution: {
          type: 'v2',
          value: [1, 1],
        },
        textureResolution: {
          type: 'v2',
          value: [textureWidth, textureHeight],
        },
        viewRatio: {
          type: 'f',
          value: 1,
        },
        textureRatio: {
          type: 'f',
          value: 1,
        },
        textureScale: {
          type: 'f',
          value: 1,
        },
        time: {
          type: 'f',
          value: 0.0,
        },
        offsetX:{
          type: 'f',
          value: 0.0
        },
        offsetY: {
          type: 'f',
          value: 0.0
        },
        scale:           {type: '1f', value: this.data.ds},
        offset:          {type: '2f', value:{x:0, y:0}},
        mapDimensions:   {type: '2f', value:{x:1, y:5112}},
        dimensions:      {type: '4fv', value:[0,0,0,0]},
        focus:           {type: '1f', value:0.5},
        enlarge:         {type: '1f', value: this.data.de},
      },
      vertexShader: vert,
      fragmentShader: normalFrag,
    })



  }



})
